/**
 * @desc 完成同个实例id并行任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<defs.activiti.ActivitiTaskInfoDto>;
export function request(
  body: defs.activiti.ActivitiCompleteBusinessDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/completeParallelTaskGetInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
